var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"Fixed",attrs:{"id":"preloader"}},[_c('div',{attrs:{"data-loader":"circle-side"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }